
import Vue from "vue";
import { Script } from "@/models/script";

export default Vue.extend({
	data(){
		return {
			scriptValues: [] as any[]
		};
	},
	props: {
		script: {
			type: Object as ()=>Script,
			required: true,
		}
	},
	computed: {
		title():string{
			return this.script.Name;
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		confirm(){
			let args = this.scriptValues.map((v, i) => {
				if (!this.script) return "";
				let t = this.script.ExtraArgs[i].Type;
				if (t == "date") {
					let date = v as Date;
					date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
					return date.toJSON();
				}
				return v.toString();
			});
			this.$emit("confirm", args);
		}
	},
});
